import {
  BrowserRouter as Router,
  Route,
  Routes,
  createBrowserRouter,
  Navigate,
  Outlet,
} from "react-router-dom";
import Header from "./components/header";
import UserListTable from "./components/usermgmt/usermgmt";
import HomePage from "./components/homepage/homepage";
import LoginPage from "./components/auth/login/login";
import ForgotPassword from "./components/auth/forgotPassword/forgotpassword";
import { UserBase } from "./components/usermgmt/userbase";
import { PasswordReqBase } from "./components/passwordreqmgmt/passwordreqbase";
import PasswordReqListTable from "./components/passwordreqmgmt/passwordreqmgmt";
import { VehicleBase } from "./components/vehiclemgmt/vehicelbase";
import VehicleListTable from "./components/vehiclemgmt/vehiclemgmt";
import { ModelBase } from "./components/modelmgmt/modelbase";
import ModelListTable from "./components/modelmgmt/modelmgmt";

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const ProtectedLayout = () => {
  return (
    <>
      <Header />
      {/* <Outlet /> */}
    </>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <LoginPage />,
  },
  {
    path: "/forgotpassword",
    element: <ForgotPassword />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "",
    element: (
      <ProtectedRoute>
        <ProtectedLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="home" />,
      },
      {
        path: "home",
        element: <HomePage />,
      },
      {
        path: "usermanagement",
        element: <UserBase />,
        children: [
          {
            index: true,
            element: <UserListTable />,
          },
        ],
      },
      {
        path: "vehiclemanagement",
        element: <VehicleBase />,
        children: [
          {
            index: true,
            element: <VehicleListTable />,
          },
        ],
      },
      {
        path: "modelmanagement",
        element: <ModelBase />,
        children: [
          {
            index: true,
            element: <ModelListTable />,
          },
        ],
      },
      {
        path: "passwordreqmanagement",
        element: <PasswordReqBase />,
        children: [
          {
            index: true,
            element: <PasswordReqListTable />,
          },
        ],
      },
    ],
  },
]);

export default router;
